import bg from '../../../../static/images/loader/background.png';

export const extendContainer = () => ({
    container: ({ theme: { colors } }) => ({
        backgroundColor: colors.darkBlue,
        backgroundImage: `url(${bg})`,
        backgroundSize: 'contain',
        position: 'relative',
    }),
});

export const extendContainerInner = () => ({
    container: () => ({
        paddingBottom: '3.875rem',
        // TODO: find a solution to remove !important
        paddingTop: '4.69rem!important',
        tabletLarge: {
            paddingBottom: '3.875rem',
        },
    }),
});

export const imagesContainer = () => ({
    gridColumn: 'auto / span 12',
    marginBottom: '5rem',
    position: 'relative',
});

export const imagesBottomContainer = () => ({
    gridColumn: 'auto / span 12',
    position: 'relative',
    height: '6.27531rem',
    marginTop: '-1.5688rem',
});

export const imgRight = () => ({
    position: 'absolute',
    right: 0,
    top: 16,
});

export const imgBottomRight = () => ({
    position: 'absolute',
    right: 0,
});

export const imgLeft = () => ({
    position: 'absolute',
});

export const imgBottomLeft = () => ({
    position: 'absolute',
    top: 76,
});

export const extendText = () => ({
    text: ({ theme: { colors } }) => ({
        color: colors.white,
        marginBottom: '0',
        marginLeft: '4rem',
        width: 'fit-content',
        position: 'relative',
        top: 8,
    }),
});

export const imgBefore = () => ({
    position: 'absolute',
});

export const copySocialWrapper = () => ({
    display: "flex",
    flexWrap: "wrap",
    gridColumn: "span 12",
    justifyContent: "space-between"
})